import React, { Suspense } from 'react'

const CheckoutPageBase = React.lazy(() => import('./Checkout'))

export const CheckoutPage = () => (
  <Suspense fallback={null}>
    <CheckoutPageBase />
  </Suspense>
)
